import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
  withXsrfConfiguration,
} from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideClientHydration,
  withHttpTransferCacheOptions,
  withIncrementalHydration,
} from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';

import localeEsCO from '@angular/common/locales/es-CO';

import { providePrimeNG } from 'primeng/config';
import { provideMarkdown } from 'ngx-markdown';

import { authInterceptor } from 'zenith/auth';
import { provideContext } from 'zenith/context';

import { httpInterceptorProviders } from '@core/interceptor';

import { routes } from './routes';
import { MyPreset } from './app.theme';

registerLocaleData(localeEsCO, 'es-CO');

import { provideMenu } from '@core/provider/menu.provider';
import { provideUserTenants } from '@core/provider/tenant.provider';
import { provideAnalyticsConfig } from '@core/provider/analytics.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    ...httpInterceptorProviders,
    provideAnimationsAsync(),
    provideRouter(routes, withComponentInputBinding()),
    provideClientHydration(withHttpTransferCacheOptions({}), withIncrementalHydration()),
    { provide: LOCALE_ID, useValue: 'es-CO' },
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: { darkModeSelector: '[data-theme="dark"]' },
      },
    }),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor]),
      withInterceptorsFromDi(),
      withXsrfConfiguration({
        cookieName: '_csrf',
        headerName: 'x-csrf-token',
      })
    ),
    provideMarkdown(),
    provideContext(),
    provideMenu(),
    provideUserTenants(),
    provideAnalyticsConfig(),
  ],
};
